import React, {useState} from 'react';
import { ToolbarButton, Icon } from 'react-onsenui';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import _ from 'lodash';
import '../ToolbarRightMenuButton.css';
import { List, Switch, ActionSheet } from 'antd-mobile';
import { addBatchCustomData, removeBatchCustomData } from '../../../services/notifications';

const ToolbarRightMenuButtonSpectator = props => {
    const [receiveNotif, setReceiveNotif] = useState(localStorage.getItem(`/notif/lives/${props.idLive}`) || 1);

    const showActionSheet = () => {
        const BUTTONS = [
            ..._.values(_.mapValues(props.settings, setting => <span style={styles.action_sheets}>{setting.name}</span>)),
            <List.Item
                wrap
                extra={
                    <Switch
                        onChange={(b) => {
                            const change = b ? 1 : 0;
                            localStorage.setItem(`/notif/lives/${props.idLive}`, change);
                            setReceiveNotif(change);

                            if(change === 1) {
                                addBatchCustomData({"ut.recipient": { "$add": [`live_${props.idLive}`]}});
                            }
                            else {
                                removeBatchCustomData([`live_${props.idLive}`]);
                            }
                        }}
                        checked={parseInt(receiveNotif) === 1} 
                        color='#004586' 
                    />
                }
            >
                <div style={{...styles.action_sheets, textAlign: 'center', marginLeft: '50%'}}>
                    Notifications
                </div>
            </List.Item>,
            <span style={styles.action_sheets}>ANNULER</span>
        ];
        ActionSheet.showActionSheetWithOptions({
          options: BUTTONS,
          cancelButtonIndex: BUTTONS.length - 1,
          destructiveButtonIndex: BUTTONS.length - 1,
          maskClosable: true,
          'data-seed': 'logId'
        },
        (k) => {
            const setting = props.settings[k];
            if(setting && setting.to) {
                props.history.push(setting.to);
            }
            else if(setting && setting.onClick) {
                setting.onClick();
            }
        });
      }

    return (
        <ToolbarButton onClick={showActionSheet}>
            <Icon size={25} icon='md-more' />
        </ToolbarButton>
    )
}

const styles = {
    action_sheets: {
        fontFamily: 'fff-equipe', 
        fontSize: '15px', 
        color: '#004586', 
        fontWeight: 700,
    }
}

ToolbarRightMenuButtonSpectator.propTypes = {
    settings: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string,
        to: PropTypes.string,
        name: PropTypes.string,
    })).isRequired,
    idLive: PropTypes.number
}

export default withRouter(ToolbarRightMenuButtonSpectator);